import { useQuery } from '@tanstack/react-query';
import { UserService } from '@/services/users/UserService';

export const useUserData = (userId: string | undefined) => {
  return useQuery({
    queryKey: ["auth", "userData", userId],
    queryFn: () => UserService.getUserData(userId!),
    enabled: !!userId,
    staleTime: Infinity,
    gcTime: 24 * 60 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
